import type {AUParam} from '@financial/common-logs'

const INFLOW_AU_COMMON_PARAMS: Pick<AUParam, 'service' | 'page'> = {service: 'md', page: 'bank'}

const 적금_만기일_알림: AUParam = Object.assign({area: 'D', code: 'myasset_bank_expire'}, INFLOW_AU_COMMON_PARAMS)
const 신규계좌_개설_알림: AUParam = Object.assign({area: 'B', code: 'myasset_bank_new'}, INFLOW_AU_COMMON_PARAMS)
const 은행_대량사용액_발생_알림: AUParam = Object.assign(
    {area: 'B', code: 'myasset_bank_spend'},
    INFLOW_AU_COMMON_PARAMS,
)

export const INFLOW_AU_LOG = {
    적금_만기일_알림,
    신규계좌_개설_알림,
    은행_대량사용액_발생_알림,
}

export const INFLOW_TO_AU_LOG: Record<string, AUParam> = {
    MYASSET_BANK_EXPIRE: 적금_만기일_알림,
    MYASSET_BANK_NEW: 신규계좌_개설_알림,
    MYASSET_BANK_SPEND: 은행_대량사용액_발생_알림,
}
